import React from 'react';

import Loader from "../../../components/Loader";
import {OptionalContent} from "../../../components/OptionalContent";
import useAlloggiatiAccounts from "./useAlloggiatiAccounts";
import AlloggiatiAccountForm from "./AlloggiatiAccountForm";

import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import CardActions from "@mui/material/CardActions/CardActions";
import List from "@mui/material/List";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Container from "@mui/material/Container";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ListItemButton from "@mui/material/ListItemButton";
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";
import CardContent from "@mui/material/CardContent";


const AlloggiatiAccountsCard = () => {

    const {
        alloggiatiAccounts,
        isLoading,
        formCreate,
        formEdit,
        handleEditAccount,
        selectedAccount,
        handleDelete
    } = useAlloggiatiAccounts()

    return (
        <Card>
            <CardContent>
                <Container maxWidth='sm' disableGutters>
                    <Loader isLoading={isLoading}>
                        <OptionalContent hasContent={alloggiatiAccounts.length > 0}
                                         noContentMessage="Nessun account alloggiati presente."
                                         showIcon>
                            <List>
                                {
                                    alloggiatiAccounts.map((a, i) => (
                                        <React.Fragment key={a.id}>
                                            <ListItem disablePadding>
                                                <ListItemButton disableGutters onClick={() => handleEditAccount(a)}>
                                                    <ListItemText primary={a.nickname} secondary={a.username}/>
                                                    <IconButton>
                                                        <EditIcon/>
                                                    </IconButton>
                                                    <IconButton onClick={(e) => handleDelete(e, a.id)}>
                                                        <DeleteIcon/>
                                                    </IconButton>
                                                </ListItemButton>
                                            </ListItem>
                                            {i !== alloggiatiAccounts.length - 1 && <Divider/>}
                                        </React.Fragment>
                                    ))
                                }
                            </List>
                        </OptionalContent>
                    </Loader>

                </Container>
            </CardContent>
            <CardActions sx={{justifyContent: "flex-end", py: 2, px: 3}}>
                <Button type="submit" variant="contained" onClick={formCreate.open}>
                    Aggiungi account
                </Button>
            </CardActions>

            {formEdit.show && <EditDialog onClose={formEdit.close} account={selectedAccount}/>}
            {formCreate.show && <CreateDialog onClose={formCreate.close}/>}
        </Card>
    );
};

const CreateDialog = (props) => {
    const {onClose} = props;
    const {createAlloggiatiAccount} = useAlloggiatiAccounts();

    const handelCreate = async (data) => {
        await createAlloggiatiAccount(data);
        onClose();
    }

    return <Dialog fullWidth open={true} onClose={onClose}>
        <DialogTitle>Crea nuovo account</DialogTitle>
        <DialogContent>
            <AlloggiatiAccountForm onSave={handelCreate}/>
        </DialogContent>
    </Dialog>

}

const EditDialog = (props) => {
    const {onClose, account} = props;
    const {updateAlloggiatiAccount} = useAlloggiatiAccounts();

    const handleEdit = async (data) => {
        await updateAlloggiatiAccount({id: account.id, ...data});
        onClose();
    }

    return <Dialog fullWidth open={true} onClose={onClose}>
        <DialogTitle>Aggiorna account</DialogTitle>
        <DialogContent>
            <AlloggiatiAccountForm onSave={handleEdit} account={account}/>
        </DialogContent>
    </Dialog>
}

export default AlloggiatiAccountsCard;